import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const SuspiciousActivityCard = ({ activity, onInvestigate, onDismiss, onSuspend }) => {
  const getSeverityBadge = () => {
    const badges = {
      critical: 'bg-error text-error-foreground',
      high: 'bg-warning text-warning-foreground',
      medium: 'bg-accent/10 text-accent',
      low: 'bg-muted text-muted-foreground'
    };
    return badges?.[activity?.severity] || 'bg-muted text-muted-foreground';
  };

  const getViolationIcon = () => {
    const icons = {
      'anonymity-breach': 'Shield',
      'circumvention': 'Shield',
      'spam': 'AlertTriangle',
      'inappropriate': 'Flag'
    };
    return icons?.[activity?.violationType] || 'AlertCircle';
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 elevation-sm border-2 border-error/20">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
          <Icon name={getViolationIcon()} size={20} color="var(--color-error)" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h4 className="text-base md:text-lg font-semibold text-foreground line-clamp-1">
              {activity?.title}
            </h4>
            <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getSeverityBadge()}`}>
              {activity?.severity}
            </span>
          </div>
          
          <div className="flex items-center gap-2 mb-3">
            <Image 
              src={activity?.userAvatar} 
              alt={activity?.userAvatarAlt}
              className="w-6 h-6 rounded-full object-cover"
            />
            <span className="text-sm text-foreground">{activity?.userName}</span>
            <span className="text-xs text-muted-foreground">•</span>
            <span className="text-xs text-muted-foreground">{activity?.detectedDate}</span>
          </div>

          <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
            {activity?.description}
          </p>

          <div className="bg-muted/50 rounded-lg p-3 mb-3">
            <p className="text-xs text-muted-foreground mb-1">Detected Content</p>
            <p className="text-sm text-foreground font-mono">{activity?.flaggedContent}</p>
          </div>

          <div className="flex flex-wrap gap-2">
            {activity?.violations?.map((violation, index) => (
              <span key={index} className="px-2 py-1 rounded-full text-xs bg-error/10 text-error">
                {violation}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          iconName="Search" 
          iconPosition="left"
          onClick={() => onInvestigate(activity)}
          className="flex-1"
        >
          Investigate
        </Button>
        <Button 
          variant="destructive" 
          size="sm" 
          iconName="Ban" 
          iconPosition="left"
          onClick={() => onSuspend(activity)}
          className="flex-1"
        >
          Suspend User
        </Button>
        <Button 
          variant="ghost" 
          size="sm" 
          iconName="X" 
          iconPosition="left"
          onClick={() => onDismiss(activity)}
          className="flex-1"
        >
          Dismiss
        </Button>
      </div>
    </div>
  );
};

export default SuspiciousActivityCard;